export const isMessageTextValid = (
  text: string,
  minMessageLength: number,
  maxMessageLength: number,
) =>
  text.length !== 0 &&
  text.length >= minMessageLength &&
  text.length <= maxMessageLength;
